<template>
    <section class="ai-top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'ai'}" :active="this.$router.currentRoute.name == 'ai'">AI Request</b-nav-item>
                <b-nav-item :to="{name: 'aiList'}" :active="this.$router.currentRoute.name == 'aiList'">Request list</b-nav-item>
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "topMenu"
    }
</script>

<style scoped>
    .goods-top-menu {
        margin-bottom: 20px;
    }
</style>